import React from 'react'

const Error = () =>{
    return(
        <>
       <h1 className="text-center p-5 text-white" style={{"backgroundColor": "blue" , "margin-top" : "200px"}}>OOP's 404 ERROR PAGE NOT FIND </h1>
        
        </>
    )
}

export default Error;